<template>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">

                
                    <label class="col-form-label">
                        <code class="highlighter-rouge">*</code> {{$t('string.msg.select.month.label')}}
                    </label>
                    <select class="form-control" v-model="result" @change="onChange(result)"> 
                        <option :value="item" v-bind:key="item" v-for="item in items">
                            {{item.date}}
                        </option>
                    </select>
                    <div v-if="partionalResults && partionalResults.length > 0">
                        <div class="table-responsive">
                            <table class="table table-centered table-hover mb-0" id="datatable">
                                <thead>
                                    <tr >
                                        <th class="border-top-0">{{$t('str.service.name.label')}}</th>
                                        <th class="border-top-0">{{$t('str.service.qtde.label')}}</th>
                                    </tr>
                                </thead>
                                <tbody v-bind:key="item" v-for="item in partionalResults" class="cursor-pointer">
                                        <tr >
                                            <td>
                                                <span v-if="item.service && item.service._id">
                                                    {{item.service._id.name}}
                                                </span> 
                                            </td>
                                            <td>
                                                <span v-if="item.countOrders">
                                                    {{item.countOrders}}
                                                </span>
                                            </td>                   
                                        </tr>
                                </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Controller from './CrtListServices';
export default {
  name: 'ListServices',
  props: ["valuekey"],
    watch:{
        'valuekey'(){
        }
    },
  components: {
  },
  data() {
      return {
        errors: [],
        titleToast: null,
        messageToast: null,
        messageIdToast: null,
        result: null,
        partionalResults: [],
        items: [],
        pageOfItems: [],
        filters: {
            name: '',
            skip: 0,
            limit: 999999
        
        },
      }
  },
  methods: Controller.methods,
  created() {
    Controller.init(this);

  },
  mounted(){
      }

  }

</script>

<style>
</style>
